import api from './api';

export interface Partner {
  id: number;
  name: string;
  logo: string;
  website: string;
  order: number;
  visible: boolean;
}

export const partnerService = {
  async list() {
    const { data } = await api.get<{ data: Partner[] }>('/partners');
    return data.data;
  },

  async create(payload: Partial<Partner>) {
    const { data } = await api.post<Partner>('/partners', payload);
    return data;
  },

  async update(id: number, payload: Partial<Partner>) {
    const { data } = await api.put<Partner>(`/partners/${id}`, payload);
    return data;
  },

  async delete(id: number) {
    await api.delete(`/partners/${id}`);
  },

  async reorder(ids: number[]) {
    await api.post('/partners/reorder', { ids });
  },
};
